<div [id]="identifier" class="interact-widget widget widget--is-docked" (mousedown)="onMouseDown()" #widgetWrapper>
  <div class="widget__inner">
    <div class="widget__header" 
    [ngClass]="(this.state === 2 || this.state === 3) ? 'widget__header--undocked' : 'widget__header--docked'">
      <h3 class="widget__title" [translate]="'widgets.' + widgetName + '.name'">Widget Title</h3>
      <button *ngIf="(this.state === 2 || this.state === 3)" class="widget__header__button" mat-flat-button (click)="onDockButtonClicked()">
        <app-asset-icon icon="dock"></app-asset-icon>
      </button>
    </div>

    <div class="widget__content">
      <ng-template #widgetInsertionPoint></ng-template>
    </div>
  </div>

  <div class="widget__resizer" 
    *ngIf="(this.state === 2|| this.state === 3)">
    <mat-icon>code</mat-icon>
  </div>
</div>
